export const setSessionStorageWithExpiry = (
  key: string,
  value: any,
  numHours: number = 1,
) => {
  const ttl = 60 * 60 * 1000 * numHours;
  const now = new Date();
  const item = { value, expiry: now.getTime() + ttl };
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const getSessionStorageWithExpiry = (key: string) => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    return null;
  }
  return item.value;
};
